import * as React from 'react';
import { Attributes } from '../types';
import Box, { BoxProps } from '../Box/Box';

export interface FormInputHeaderProps extends BoxProps {}

const FormInputHeader: React.ForwardRefRenderFunction<HTMLDivElement, Attributes<HTMLDivElement, FormInputHeaderProps>> = (props, ref) => {
  const { ...rest } = props;

  return (
    <Box { ...rest }
        alignChildrenVertical="end"
        className="FormInputHeader"
        flex="horizontal"
        gap="x2"
        margin="x3"
        ref={ ref } />
  );
};

export default React.forwardRef(FormInputHeader);
